import { getUpdatedLeague } from '../helpers/getUpdatedLeague';

const initialState = {
    loading: false,
    data: null,
    error: null,
    showForm: false,
  };
  
  const leagueReducer = (
    state = initialState,
    action
  ) => {
    switch (action.type) {
      case "LEAGUE_PENDING":
        return {
          ...state,
          loading: true,
        };
      case "LEAGUE_SUCCESS":
        return {
          ...state,
          loading: false,
          error: null,
          data: action.payload,
        };
      case "LEAGUE_ERROR":
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      case "MATCH_DELETE":
        return {
          ...state,
          data: getUpdatedLeague(
            'delete',
            state.data,
            action.payload.matchDayId,
            action.payload.matchId
          ),
        };
      case "MATCH_ADD":
        return {
          ...state,
          data: getUpdatedLeague(
            'add',
            state.data,
            action.payload.matchDayId,
            action.payload.matchId
          ),
        };
      case "NEW_MATCH_DAY":
        return {
          ...state,
          data: {
            ...state.data,
            matchDays: [
              action.payload,
              ...state.data.matchDays
            ]
          },
        };
        case "MATCH_DAY_FORM":
          return {
            ...state,
            showForm: action.payload,
          }
      default:
        return state;
    }
  };
  
  export default leagueReducer;
  